import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import createPersistedState from 'vuex-persistedstate'

import alert from './modules/alert'
import auth from './modules/auth'
import localPreferences from './modules/local-preferences'
import selection from './modules/selection'
import quickSums from './modules/quick-sums'
import places from './modules/places'

import { api, endpoints } from '@/api'
import router from '@/router'

Vue.use(Vuex)
const debug = (process.env.NODE_ENV !== 'production') && false

const plugins = []

if (debug) {
  plugins.push(createLogger())
}

plugins.push(createPersistedState({
  paths: ['localPreferences'],
}))

const store = new Vuex.Store({
  modules: {
    alert,
    auth,
    localPreferences,
    selection,
    quickSums,
    places
  },
  strict: debug,
  plugins: plugins
})
store.dispatch('probeLogin')

export default store
